<template>
  <base-container>
    <div
      class="padding7 back-white"
      style="display: flex; justify-content: space-between; margin-top: 7px"
    >
      <div>
        <!-- <span class="text-bold" v-text="tenant.name"></span>
        <span class="margin-h5">--</span> -->
        <span>登录用户【{{ user.name }}】</span>
      </div>
      <div>
        <i class="el-icon-time margin-h7 color-blue"></i>
        <span>今天是</span>
        <span class="text-bold" v-text="data.todayCalendar"></span>
      </div>
    </div>

    <div class="padding7 margin-v7">
      <el-row>
        <el-col
          :xs="12"
          :sm="8"
          :md="6"
          :lg="6"
          :xl="5"
          style="padding: 5px 5px"
        >
          <el-card style="height: 100px">
            <span class="text-bold" slot="header">检查预约数</span>
            <el-row
              class="color-danger"
              style="font-size: 27px"
              type="flex"
              justify="space-between"
              align="middle"
            >
              <span v-text="data.jcCount"></span>
              <span class="el-icon-s-opportunity"></span>
            </el-row>
          </el-card>
        </el-col>
        <!-- <el-col
          :xs="12"
          :sm="8"
          :md="6"
          :lg="6"
          :xl="5"
          style="padding: 5px 5px"
        >
          <el-card style="height: 100px">
            <span slot="header">检验预约数</span>
            <el-row
              class="color-primary"
              style="font-size: 27px"
              type="flex"
              justify="space-between"
              align="middle"
            >
              <span v-text="data.jyCount">12</span>
              <span class="el-icon-warning"></span>
            </el-row>
          </el-card>
        </el-col>
        <el-col
          :xs="12"
          :sm="8"
          :md="6"
          :lg="6"
          :xl="5"
          style="padding: 5px 5px"
        >
          <el-card style="height: 100px">
            <span slot="header">治疗预约数</span>
            <el-row
              class="color-success"
              style="font-size: 27px"
              type="flex"
              justify="space-between"
              align="middle"
            >
              <span v-text="data.zlCount">12</span>
              <span class="el-icon-bell"></span>
            </el-row>
          </el-card>
        </el-col>
        <el-col
          :xs="12"
          :sm="8"
          :md="6"
          :lg="6"
          :xl="5"
          style="padding: 5px 5px"
        >
          <el-card style="height: 100px">
            <span slot="header">床位预约数</span>
            <el-row
              class="color-warning"
              style="font-size: 27px"
              type="flex"
              justify="space-between"
              align="middle"
            >
              <span v-text="data.bedCount">12</span>
              <span class="el-icon-menu"></span>
            </el-row>
          </el-card>
        </el-col> -->
      </el-row>
    </div>
    <div class="back-white" style="padding: 20px 20px">
      <div id="chart" style="height: 500px"></div>
    </div>
  </base-container>
</template>

<script>
import { mapGetters } from "vuex";
import { desktop } from "@/api/home";
import * as echarts from "echarts";
export default {
  components: {},
  data() {
    return {
      intervalVal: "",
      data: {
        todayCalendar: "",
        jcCount: 0,
        jyCount: 0,
        zlCount: 0,
        trendTimeSpans: [],
        data: [],
      },
      option: {
        title: {
          text: "预约业务量监控(最近24小时)",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          data: ["检查预约", "检验预约", "治疗预约", "床位预约"],
          left: "right",
        },
        color: ["#F56C6C", "#4995f9", "#41d68c", "#FFCC00"],
        grid: {
          left: "1%",
          right: "1%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: [],
        },
        yAxis: [
          {
            type: "value",
          },
        ],
        series: [],
      },
    };
  },
  computed: {
    ...mapGetters(["user"]),
  },
  mounted() {
    this.loadData();
    // this.intervalVal = setInterval(this.loadData, 5 * 1000);
  },
  destroyed() {
    // clearInterval(this.intervalVal);
  },
  methods: {
    loadData() {
      desktop().then((res) => {
        this.data = res.data.data;
        this.$nextTick(() => {
          this.initChart();
        });
      });
    },
    initChart() {
      var myChart = echarts.init(document.getElementById("chart"));

      this.initChartOption();
      myChart.setOption(this.option);

      window.addEventListener("resize", () => {
        myChart.resize();
      });
    },
    initChartOption() {
      if (this.data.trendTimeSpans) {
        this.option.xAxis.data = [];
        this.data.trendTimeSpans.forEach((item) => {
          this.option.xAxis.data.push(item);
        });
      }
      if (this.data.data) {
        this.option.series = [];
        this.data.data.forEach((e) => {
          this.option.series.push({
            name: e.name,
            type: "line",
            stack: "总量",
            smooth: true,
            lineStyle: {
              width: 0,
            },
            showSymbol: false,
            areaStyle: {},
            emphasis: {
              focus: "series",
            },
            data: e.counts,
          });
        });
      }
    },
  },
};
</script>

<style>
</style>